// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "27c8330337d6c08b73f2" + ".css";
};